import React from 'react';
import { Box } from '@mui/joy';

export const Logo = ({ size = 40 }) => {
  return (
    <Box
      component="img"
      src="/logo.png"
      alt="CTS Logo"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
      }}
    />
  );
};
